export const MAX_FILTERS_PER_GROUP = 10;
